import { apiGet } from './api';

export interface LiveRoom {
  roomId: number;
  roomNo?: string;
  roomName?: string;
  roomImg?: string | null;
  userId?: number;
  userName?: string | null;
  handle?: string | null;
  avatar?: string | null;
  roomUserCount?: number;
  giftCounts?: number;
  status?: number;
  roomType?: number;
  createTime?: string;
}

export interface LiveRoomPage {
  list: LiveRoom[];
  totalCount: number;
  totalPage: number;
  currPage: number;
  pageSize: number;
}

export async function fetchActiveLiveRooms(page = 1, limit = 50, search?: string): Promise<LiveRoomPage> {
  let url = `/api/live-room/active?page=${page}&limit=${limit}`;
  if (search && search.trim()) {
    url += `&search=${encodeURIComponent(search.trim())}`;
  }
  const res = await apiGet<{ code: number; data: LiveRoomPage; msg?: string }>(url);
  if (res.code !== 0) throw new Error(res.msg || '查询直播间列表失败');
  return res.data;
}
